import React from "react";
import "../../styles/components/marketplace-shared.css";

const SurfaceCard = ({
  as: Component = "section",
  className = "",
  eyebrow,
  title,
  actions,
  children,
}) => (
  <Component className={`marketplace-surface-card ${className}`.trim()}>
    {(eyebrow || title || actions) ? (
      <div className="marketplace-surface-card__header">
        <div>
          {eyebrow ? <span className="marketplace-surface-card__eyebrow">{eyebrow}</span> : null}
          {title ? <h3 className="marketplace-surface-card__title">{title}</h3> : null}
        </div>
        {actions ? <div className="marketplace-surface-card__actions">{actions}</div> : null}
      </div>
    ) : null}
    {children}
  </Component>
);

export default SurfaceCard;


